import { createContext, useContext } from 'react'

/**
 * Le verrou de clôture.
 *
 * Tant que le point du cycle écoulé n'est pas fait, PLUS RIEN ne se modifie
 * dans l'app. Ce n'est pas une insistance de confort : la clôture demande à
 * l'utilisateur ce qui a vraiment été dépensé sur le cycle passé, et elle le
 * calcule sur l'état du moment. Une dépense saisie, une enveloppe changée ou
 * une journée confirmée entre l'ouverture de la question et sa réponse
 * déplacerait les chiffres sous les pieds de l'utilisateur — il répondrait sur
 * un reste qui n'existe plus, et le cycle suivant partirait faux.
 *
 * Voir et naviguer restent possibles : on ne prend pas l'app en otage, on
 * empêche seulement d'écrire. Décision 2026-08-23.
 */
export const CycleLockContext = createContext(false)

/** Vrai quand une clôture est due, donc quand toute écriture doit être refusée. */
export function useCycleLocked(): boolean {
  return useContext(CycleLockContext)
}
